
export default {
    apiKey: "AIzaSyAhyeyHxV0ITNFv-EjiAUkn3hdHUORyOJQ",
    authDomain: "pixapup-dev-74407.firebaseapp.com",
    projectId: "pixapup-dev-74407",
    storageBucket: "pixapup-dev-74407.appspot.com",
    messagingSenderId: "95346633121",
    appId: "1:95346633121:web:fd3d158fb77f9edc69c3e0"
};


